import React, { useState, useContext, useEffect, useRef } from "react";
import moment from "moment";
import { AppContext } from "../../context/AppContext";
import optionIcon from "../../assets/images/bx_edit.svg";
import shareIcon from "../../assets/images/ic_export1.svg";
import BookIcon from "../../assets/images/ic_excel.svg";
import "../../assets/css/myAttendence.scss";
import ReactPaginate from "react-paginate";
import { PostCallWithErrorResponse } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import Loader from "../Loader";
import FileSaver from "file-saver";
import ExcelLoader from "../../sharedComponent/ExcelLoader";
import NoData from "../../sharedComponent/NoData";
import Modal from "react-bootstrap/Modal";
import { ToastMsg } from "../TostMsg";

const MyAttendence = () => {
  const { sidebar, setSidebar, Dark, setDark, userData, permissions, getYearFromJoiningOfLoginUser,
    yearsFromJoining } =
    useContext(AppContext);
  const [attendanceList, setAttendanceList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);

  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };
  const minOffset = 0;
  const maxOffset = 1;
  let crryear = new Date().getFullYear();
  let allYears = [];
  for (let x = 0; x <= maxOffset; x++) {
    allYears.push(crryear - x);
  }
  const [monthArr, setMonthArr] = useState([
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ]);

  const [attendancePayLoad, setAttendancePayLoad] = useState({
    EmployeeId: Number(userData.EmpId),
    // OrgId: Number(userData.OrgId),
    Month: new Date().getMonth() + 1,
    Year: new Date().getFullYear(),

  
  ExportToExcel: false
  });

  useEffect(() => {
    getYearFromJoiningOfLoginUser()
  }, [])

  useEffect(() => {
    getAttendanceList();
  }, [attendancePayLoad]);
  const getAttendanceList = () => {
    setLoading(false);
    if (attendancePayLoad.Month >= 1 && attendancePayLoad.Year) {
      setLoading(true);
      PostCallWithErrorResponse(
        ApiConfig.NewApiATTENDANCE_LIST,
        JSON.stringify(attendancePayLoad)
      )
        .then((res) => {
          console.log("Shift time data ------>>>", res.json?.Data.ShiftTime);

          setLoading(false);
          setAttendanceList(
            res.json?.Data.Attendance ? res.json?.Data.Attendance : []
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const downLoadExcelSheet = () => {
    setExcelLoading(true);
    let body = {
      EmpId: Number(userData.EmpId),
      OrgId: Number(userData.OrgId),
      Month: attendancePayLoad.Month,
      Year: attendancePayLoad.Year,
      ExportToExcel: true,
    };
    PostCallWithErrorResponse(ApiConfig.ATTENDANCE_LIST, JSON.stringify(body))
      .then((res) => {
        console.log("res", res);
        if (res.error) {
          console.log("Error response", res);
        } else {
          if (res.json.Success === true) {
            setExcelLoading(false);
            let data = res.json.Data;
            FileSaver.saveAs(
              "data:" + data.ContentType + ";base64," + data.FileContents,
              data.FileDownloadName
            );
          } else {
            console.log("res", res);
            setExcelLoading(false);
          }
        }
      })
      .catch((err) => {
        setExcelLoading(false);
        console.log(err);
      });
  };

  const [editRecord, setEditRecord] = useState(false);
  const handleClose = () => setEditRecord(false);
  const [isLoading, setIsLoading] = useState(false);
  const [updatePayloadData, setupdatePayloadData] = useState({
    Id: 0,
    EmpId: Number(userData.EmpId),
    OrgId: Number(userData.OrgId),
    Intime: "",
    OutTime: "",
    Date: "",
    InPlatform: 1,
    OutPlatform: 1,
  });

  const convertTime12to24forPunchOutTime = (time12h) => {
    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":");
    if (hours === "12") { hours = "00"; }
    if (modifier === "PM") { hours = parseInt(hours, 10) + 12; }
    else { hours = parseInt(hours, 10); }
    return `${hours < 10 ? 0 : ""}${hours}:${minutes}`;
  };

  const UpdateTimeApi = () => {
    setIsLoading(true);
    PostCallWithErrorResponse(ApiConfig.UPDATE_TIME, JSON.stringify(updatePayloadData))
      .then((res) => {
        if (res.json && res.json?.Success === true) {
          ToastMsg("success", res.json.Message);
          setIsLoading(false);
          handleClose();
          getAttendanceList();
        } else {
          ToastMsg("error", res.json.Message);
          setIsLoading(false);
        }
      })
      .catch((err) => { console.log(err); });
  };

  return (
    <>
      <div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
      >
        <div className="role-content-main">
          <div className="sub-header-role mb-4">
            <h6 className="mt-2">My Attendance </h6>
          </div>
          <div className="d-flex justify-content-between mainHeader custom-mb">
            <div className="role-table-header-main">
              <div className="search-input-wrapper-main">
                <select
                  className="form-select input-select-option"
                  aria-label="Default select example"
                  onChange={(e) => {
                    // setYear(Number(e.target.value) + 1).toString();
                    setAttendancePayLoad({
                      ...attendancePayLoad,
                      Year: Number(e.target.value),
                    });
                  }}
                  value={attendancePayLoad.Year}
                >
                  {/* <option value='' selected>Select Year</option> */}
                  {yearsFromJoining?.years?.map((year, i) => {
                    return (
                      <option key={i} value={year?.year}>
                        {year?.year}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="search-input-wrapper-main mx-4">
                <select
                  className="form-select input-select-option"
                  aria-label="Default select example"
                  onChange={(e) => {
                    // setMonth(e.target.value);
                    setAttendancePayLoad({
                      ...attendancePayLoad,
                      Month: Number(e.target.value),
                    });
                  }}
                  value={attendancePayLoad.Month}
                >
                  {/* <option value=''>Select Month</option> */}
                  {monthArr &&
                    monthArr.map((data, index) => {
                      return (
                        <option value={data?.value} key={index}>
                          {data?.label}
                        </option>
                      );
                    })}
                </select>
              </div>
            </div>
            <div className="d-flex justify-content-between mainIcons">
              {/* <div className="shareIcon mx-3">
                <img src={shareIcon} className="innerIconsBtn" alt="" />
              </div> */}
              {permissions && permissions["My Attendance Export"] && (
                <div className="booksIcon" style={{ textAlign: "center" }}>
                  {excelLoading ? (
                    <ExcelLoader />
                  ) : (
                    <img
                      src={BookIcon}
                      className="innerIconsBtn"
                      alt=""
                      onClick={(e) => {
                        downLoadExcelSheet();
                      }}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
          {/* <div className='emptyPage'>
                        <img src={emptypage} alt="" />
                    </div> */}
          <div className="table-wrapper-main mb-4">
            {loading ? (
              <Loader />
            ) : (
              <table>
                <thead>
                  <tr className="firstTabelRow">
                    <th style={{ width: '40px' }}></th>
                    {/* <th>Sr. No</th> */}
                    <th>Date</th>
                    <th>Shift Timing</th>
                    <th>Check In</th>
                    <th>Check Out</th>
                    <th>Total Hours</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {attendanceList && attendanceList.length > 0 ? (
                    attendanceList.map((attend, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr className="table-row-main">
                            <td
                              style={{ cursor: 'pointer', textAlign: 'center', color: '#53B7E8' }}
                              onClick={() => toggleRow(index)}
                            >
                              {expandedRow === index ? '▲' : '▼'}
                            </td>
                            {/* <td>{index + 1}</td> */}
                            <td>{attend.DateString}</td>
                            <td>{attend.ShiftTiming}</td>
                            <td>{attend.CheckIn}</td>
                            <td>{attend.CheckOut}</td>
                            <td>
                              <span>{attend.TotalHours}</span>
                              {attend.SessionsCount > 0 && (
                                <span
                                  style={{
                                    cursor: 'pointer',
                                    backgroundColor: '#EEF8FD',
                                    border: '1px solid #53B7E8',
                                    borderRadius: '12px',
                                    padding: '2px 8px',
                                    fontSize: '10px',
                                    color: '#53B7E8',
                                    marginLeft: '8px',
                                    fontWeight: 500,
                                    display: 'inline-block',
                                  }}
                                  onClick={(e) => { e.stopPropagation(); toggleRow(index); }}
                                >
                                  {attend.SessionsCount} Sessions
                                </span>
                              )}
                            </td>
                            <td
                              className={
                                attend.Remarks === "Absent"
                                  ? "status-label-danger"
                                  : attend.Remarks === "Present" ||
                                    attend.Remarks === "Present Day"
                                    ? "status-label-green"
                                    : attend.Remarks === "Weekend" ||
                                      attend.Remarks === "Off Day"
                                      ? "status-grey"
                                      : attend.Remarks === "Late punch In" ||
                                        attend.Remarks === "Early punch Out" ||
                                        attend.Remarks === "Miss punch"
                                        ? "status-label-warning"
                                        : "status-h-leave"
                              }
                            >
                              {attend.Remarks}
                            </td>
                          </tr>
                          {expandedRow === index && (
                            <tr>
                              <td colSpan={8} style={{ padding: '0 0px 12px 0px', backgroundColor: 'transparent' }}>
                                <div style={{
                                  backgroundColor: '#fff',
                                  borderRadius: '10px',
                                  padding: '14px 18px',
                                  boxShadow: '0 2px 8px rgba(83,183,232,0.08)',
                                  border: '1px solid #ddeaf3',
                                }}>
                                  <div style={{ color: '#53B7E8', fontWeight: 700, fontSize: '13px', marginBottom: '12px', letterSpacing: '0.3px' }}>
                                    Punch Breakdown
                                  </div>
                                  <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 6px' }}>
                                    <thead>
                                      <tr>
                                        {['Session', 'Punch In', 'Punch Out', 'Session Hours', 'Action'].map((h, i) => (
                                          <th key={i} style={{
                                            backgroundColor: '#EEF8FD',
                                            color: '#333',
                                            fontSize: '11px',
                                            fontWeight: 600,
                                            padding: '8px 14px',
                                            textAlign: 'left',
                                            borderRadius: i === 0 ? '8px 0 0 8px' : i === 4 ? '0 8px 8px 0' : '0',
                                          }}>{h}</th>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {attend.PunchBreakdown && attend.PunchBreakdown.length > 0 ? (
                                        attend.PunchBreakdown.map((punch, i) => (
                                          <tr key={i}>
                                            <td style={{ padding: '7px 14px', fontSize: '12px', color: '#444', fontWeight: 500 }}>{punch.Session}</td>
                                            <td style={{ padding: '7px 14px', fontSize: '12px', color: '#444' }}>{punch.PunchIn || '-'}</td>
                                            <td style={{ padding: '7px 14px', fontSize: '12px', color: '#444' }}>{punch.PunchOut || '-'}</td>
                                            <td style={{ padding: '7px 14px', fontSize: '12px', color: '#444' }}>{punch.SessionHours || '-'}</td>
                                            <td style={{ padding: '7px 14px', fontSize: '12px' }}>
                                              <img
                                                src={optionIcon}
                                                alt="edit"
                                                style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                                                onClick={() => {
                                                  const inTime24 = punch.PunchIn ? moment(punch.PunchIn, "hh:mm A").format("HH:mm") : "";
                                                  const outTime24 = punch.PunchOut ? moment(punch.PunchOut, "hh:mm A").format("HH:mm") : "";
                                                  setupdatePayloadData({
                                                    Id: punch.Id || 0,
                                                    EmpId: Number(userData.EmpId),
                                                    OrgId: Number(userData.OrgId),
                                                    Intime: inTime24,
                                                    OutTime: outTime24,
                                                    Date: attend.DateString,
                                                    InPlatform: 1,
                                                    OutPlatform: 1,
                                                  });
                                                  setEditRecord(true);
                                                }}
                                              />
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan={5} style={{ padding: '10px 14px', fontSize: '12px', color: '#828282', textAlign: 'center' }}>
                                            No punch records found
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <>
                      <tr className="ErrorDataNotFound">
                        <td colSpan={8}>
                          <NoData />
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
      {/* Modal For Edit */}
      <Modal size="md" show={editRecord} onHide={() => setEditRecord(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Record</Modal.Title>
        </Modal.Header>
        <div className="lineSeperate"></div>
        <Modal.Body>
          <div className="editModalBody">
            <div className="d-flex align-items-center diffbtns">
              <div className="mx-2"><label>In Time</label></div>
              <div>
                <input
                  value={updatePayloadData?.Intime ? convertTime12to24forPunchOutTime(updatePayloadData?.Intime) : "00:00"}
                  type="time"
                  onChange={(e) => setupdatePayloadData({ ...updatePayloadData, Intime: e.target.value })}
                />
              </div>
            </div>
            <div className="d-flex align-items-center diffbtns">
              <div className="mx-2"><label>Out Time</label></div>
              <div>
                <input
                  value={updatePayloadData?.OutTime ? convertTime12to24forPunchOutTime(updatePayloadData?.OutTime) : "00:00"}
                  type="time"
                  onChange={(e) => setupdatePayloadData({ ...updatePayloadData, OutTime: e.target.value })}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <div className="lineSeperate"></div>
        <div className="d-flex justify-content-end align-items-center mainBtnsSub">
          <button className="btn-width cancelBtn mx-3" onClick={handleClose}>Cancel</button>
          <button className="btn-width saveBtn" onClick={UpdateTimeApi} disabled={isLoading}>
            {isLoading ? (
              <div className="spinner-border mx-auto mt-2" style={{ width: "1.5rem", height: "1.5rem" }} />
            ) : "Save"}
          </button>
        </div>
      </Modal>
    </>
  );
};

export default MyAttendence;
